{
  "eyebrow": "Sie sind dabei",
  "title": "Willkommen bei Done-it, {{company}}.",
  "sub": "Ihre 30-tägige {{plan}}-Testphase ist aktiv. Drei nächste Schritte.",
  "next1": {
    "title": "Mobile App herunterladen",
    "desc": "Schicken Sie Ihrem Team den Installationslink per SMS oder E-Mail.",
    "cta": "Einladungslink senden"
  },
  "next2": {
    "title": "Ihr Team einladen",
    "desc": "Mitarbeitende per CSV-Bulk-Import oder einzeln hinzufügen.",
    "cta": "Admin öffnen"
  },
  "next3": {
    "title": "4-minütige Tour ansehen",
    "desc": "So richten Sie Ihr erstes Projekt und Ihre Standorte ein.",
    "cta": "Video ansehen"
  },
  "cta": "Zum Dashboard",
  "receipt": "Eine Quittung und Onboarding-E-Mail sind unterwegs an {{email}}.",
  "fallbacks": {
    "company": "Ihr Unternehmen",
    "plan": "Ihren Tarif",
    "inbox": "Ihren Posteingang"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Ihr {{plan}}-Konto ist aktiv — für immer kostenlos. Drei nächste Schritte."
}
